export default function StatementSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20toned%20soft%20focus%20photograph%20of%20modern%20industrial%20interior%20with%20architectural%20concrete%20surfaces%20and%20subtle%20geometric%20shadow%20patterns%2C%20warm%20amber%20and%20bronze%20lighting%20creating%20atmospheric%20depth%2C%20clean%20minimalist%20space%20with%20textured%20walls%2C%20no%20people%20no%20text%20no%20furniture%2C%20abstract%20architectural%20photography%2C%20cinematic%20mood%20with%20soft%20gradients%20and%20natural%20light%20falloff&width=1800&height=900&seq=statement-bg-feman&orientation=landscape"
        alt="Warm toned industrial interior with architectural surfaces and geometric shadows"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>

      <div className="relative z-10 text-center px-8 md:px-16 max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-white leading-[1.15] tracking-wide uppercase mb-6">
          Built for the future
        </h2>
        <p className="text-lg md:text-xl text-white/70 font-light leading-relaxed max-w-2xl mx-auto">
          We deliver reliable and future-ready IT solutions through continuous innovation, disciplined engineering, and an unwavering commitment to technical excellence.
        </p>
        <div className="mt-10 w-16 h-px bg-white/30 mx-auto"></div>
      </div>
    </section>
  );
}